import Vue from 'vue'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'

// Retorna os cadastros individuais
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_cns - CNS do profissional
 */
export async function getCadastrosIndividuais(cod_ibge, nu_cns) {
  try {
    const { data } = await Vue.prototype.$api.get(
      '/app/consultas-pre-natal/detalhado/' + cod_ibge + '/' + nu_cns
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna os cadastros individuais por microárea
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da equipe
 * @param {int} micro_area - Micro área do profissional
 */
export async function getCadastrosIndividuaisPorMicroArea(
  cod_ibge,
  nu_ine,
  micro_area
) {
  try {
    const { data } = await Vue.prototype.$api.get(
      '/app/consultas-pre-natal/detalhado/microarea/' +
        cod_ibge +
        '/' +
        nu_ine +
        '/' +
        micro_area
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna os cadastros individuais sem ACS de uma equipe
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 */
export async function getCadastrosIndividuaisSemAcs(cod_ibge, nu_ine) {
  try {
    const { data } = await Vue.prototype.$api.get(
      '/app/consultas-pre-natal/detalhado/sem-acs/' + cod_ibge + '/' + nu_ine
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna os cadastros individuais sem equipe
/**
 * @param {int} cod_ibge - IBGE do município
 */
export async function getCadastrosIndividuaisSemEquipe(cod_ibge) {
  try {
    const { data } = await Vue.prototype.$api.get(
      '/app/consultas-pre-natal/detalhado/sem-equipe/' + cod_ibge
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna os cadastros individuais todos de uma equipe
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 */
export async function getCadastrosIndividuaisTodosPorEquipe(cod_ibge, nu_ine) {
  try {
    const { data } = await Vue.prototype.$api.get(
      '/app/consultas-pre-natal/detalhado/todos/equipe/' +
        cod_ibge +
        '/' +
        nu_ine
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna o nome da cor de acordo com o valor
/**
 *
 * @param {int} valor - Valor numérico
 */
export function getCorTextoResultado(valor) {
  if (valor >= 45) {
    return 'blue'
  } else {
    return 'red'
  }
}

export function printTableRow(
  proxima_consulta,
  dt_atendimento,
  tipo_atendimento
) {
  if (
    ((new Date(proxima_consulta) < new Date() || dt_atendimento === null) &&
      tipo_atendimento == 1) ||
    dt_atendimento === null
  ) {
    return 'red'
  } else {
    return 'green'
  }
}

export function comparaQuadrimestre(dpp) {
  if (dpp != null) {
    let quadrimestre_atual = ''
    let data_atual = new Date()
    let mes_atual = parseInt(data_atual.getMonth() + 1) // janeiro=0
    let ano_atual = parseInt(data_atual.getFullYear())
    if (mes_atual >= 1 && mes_atual <= 4) {
      quadrimestre_atual = ano_atual + ' Q1'
    } else if (mes_atual >= 5 && mes_atual <= 8) {
      quadrimestre_atual = ano_atual + ' Q2'
    } else if (mes_atual >= 9 && mes_atual <= 12) {
      quadrimestre_atual = ano_atual + ' Q3'
    } else {
      quadrimestre_atual = ''
    }

    let quadrimestre_dpp = ''
    let data_dpp_split = dpp.split('-')
    let mes_dpp = data_dpp_split[1]
    let ano_dpp = data_dpp_split[0]
    if (mes_dpp >= 1 && mes_dpp <= 4) {
      quadrimestre_dpp = ano_dpp + ' Q1'
    } else if (mes_dpp >= 5 && mes_dpp <= 8) {
      quadrimestre_dpp = ano_dpp + ' Q2'
    } else if (mes_dpp >= 9 && mes_dpp <= 12) {
      quadrimestre_dpp = ano_dpp + ' Q3'
    } else {
      quadrimestre_dpp = ''
    }

    if (quadrimestre_atual == quadrimestre_dpp) {
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}

export function exibirVermelhos(cadastros) {
  let filtro = cadastros.filter((item) => {
    if (
      ((new Date(item.proxima_consulta) < new Date() ||
        item.dt_atendimento === null) &&
        item.tipo_atendimento == 1) ||
      item.dt_atendimento === null
    ) {
      return true
    } else {
      return false
    }
  })
  return filtro
}
export function exibirVerdes(cadastros) {
  let filtro = cadastros.filter((item) => {
    if (
      ((new Date(item.proxima_consulta) < new Date() ||
        item.dt_atendimento === null) &&
        item.tipo_atendimento == 1) ||
      item.dt_atendimento === null
    ) {
      return false
    } else {
      return true
    }
  })
  return filtro
}

export function generatePdf(
  cadastros,
  selectEquipe,
  selectProfissional,
  nomeProfissional
) {
  let title_pdf = 'Consultas Pré-Natal'
  let titlePdfSave = utils.methods.titlePdf(
    'Consultas Pré-Natal',
    selectEquipe.no_equipe
  )

  let description_pdf = 'Consultas de Pré-Natal realizadas em gestantes'
  let headers_pdf = [
    'NOME',
    'NASCIMENTO',
    'MA',
    'ATENDIDO',
    'FECHAR ATÉ',
    'DESFECHO',
    'DOCUMENTO',
  ]
  var data_pdf = []
  for (let i = 0; i < cadastros.length; i++) {
    var obj = {}
    obj.no_cidadao = cadastros[i].no_cidadao
    obj.dt_nascimento = utils.methods.formatDate(cadastros[i].dt_nascimento)
    obj.micro_area = cadastros[i].micro_area
    obj.dt_atendido = utils.methods.formatDate(cadastros[i].dt_atendimento)
    obj.fechar_ate = utils.methods.formatDate(cadastros[i].fechar_ate)
    if (cadastros[i].tipo_atendimento == 2) {
      obj.desfecho = 'Finalizado'
    } else if (cadastros[i].dt_atendimento == null) {
      obj.desfecho = 'Auto referido'
    } else {
      obj.desfecho = 'Aberto'
    }

    let documentoText = ''
    let lineBreak = ''
    if (cadastros[i].nu_cpf !== null && cadastros[i].nu_cpf !== undefined) {
      lineBreak = '\n'
      documentoText += `CPF ${cadastros[i].nu_cpf}`
    }
    if (cadastros[i].nu_cns !== null && cadastros[i].nu_cns !== undefined) {
      documentoText += `${lineBreak}CNS ${cadastros[i].nu_cns}`
    }
    obj.documento = documentoText
    obj.dias = cadastros[i].dias
    obj.proxima_consulta = cadastros[i].proxima_consulta
    obj.dt_atendimento = cadastros[i].dt_atendimento
    obj.tipo_atendimento = cadastros[i].tipo_atendimento
    data_pdf.push(obj)
  }
  let doc = new jsPDF(utils.methods.encryptionPdf())
  // cria a tabela
  let table = utils.methods.createTablePdf(data_pdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf
      )
      verticalPosition = utils.methods.bodyPdf(
        doc,
        [
          {
            label: 'Equipe',
            value: selectEquipe.no_equipe,
          },
          {
            label: 'CNES',
            value: selectEquipe.nu_cnes,
          },
          {
            label: 'INE',
            value: selectEquipe.nu_ine,
          },
          {
            label: 'Profissional ACS',
            value: nomeProfissional,
          },
        ],
        verticalPosition
      )

      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: function (data) {
          let proxima_consulta = data.row.raw[8]
          let dt_atendimento = data.row.raw[9]
          let tipo_atendimento = parseInt(data.row.raw[10])
          if (
            ((new Date(proxima_consulta) < new Date() ||
              dt_atendimento === null) &&
              tipo_atendimento == 1) ||
            dt_atendimento === null
          ) {
            doc.setTextColor(194, 10, 16) // vermelho
          } else {
            doc.setTextColor(2, 99, 57) //verde
          }
          // pinta a cor da descrição das colunas de preto
          if (data.row.section === 'head') {
            doc.setTextColor(0, 0, 0)
          }
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

export async function carregarSerieHistoricaPorEquipe(cod_ibge, nu_ine, xaxis) {
  try {
    let response = await Vue.prototype.$api.get(
      '/app/serie-historica/equipe/' + cod_ibge + '/' + nu_ine + '/1'
    )
    let array_chart_equipe = []
    for (let i = 0; i < xaxis.length; i++) {
      var eixo_x_atual = xaxis[i]
      for (const item of response.data) {
        var resultado = 0
        if (item.mes_ano == eixo_x_atual) {
          resultado = item.resultado
          break
        } else {
          resultado = null
        }
      }
      array_chart_equipe.push(resultado)
    }
    return array_chart_equipe
  } catch (err) {
    console.log(err)
  }
}

export function resultadoEquipe(valor, estimadas, informadas) {
  let denominador = 0
  if (parseInt(informadas) >= parseInt(estimadas)) {
    denominador = parseInt(informadas)
  } else {
    denominador = parseInt(estimadas)
  }
  let resultado = (valor / denominador) * 100
  if (Number.isNaN(resultado)) {
    return ''
  }
  return resultado.toFixed(0)
}
export async function carregarSerieHistoricaPorAcs(
  cod_ibge,
  profissional,
  xaxis
) {
  try {
    let response = await Vue.prototype.$api.get(
      '/app/serie-historica/acs/' + cod_ibge + '/' + profissional + '/1'
    )

    let array_chart_acs = []
    if (response.data.length !== 0) {
      for (let i = 0; i < xaxis.length; i++) {
        var eixo_x_atual = xaxis[i]
        for (const item of response.data) {
          var resultado = 0
          if (item.mes_ano == eixo_x_atual) {
            resultado = item.resultado
            break
          } else {
            resultado = null
          }
        }
        array_chart_acs.push(resultado)
      }
      return array_chart_acs
    } else {
      return null
    }
  } catch (err) {
    console.log(err)
  }
}
